// extracted by mini-css-extract-plugin
export default {"container":"styles_container__IIcWn","title":"styles_title__9CwEc","search":"styles_search__xn7WJ"};